import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  HashRouter,
} from "react-router-dom";
import Home from "../../pages/Home";
import RestictionWidth from "../RestrictionWidth";
import RestictionUpdate from "../RestictionUpdate";

import Table from "../Table";
import { connect } from "react-redux";
import Header from "../commons/header";
import Footer from "../commons/footer";
import Loading from "../Loading/Loading";
import { GlobalStyle } from "./styled";
import Hero from "../Hero";
import { getCardsRequest } from "../../store";
const API_KEY = `${process.env.API_KEY}`;
console.log(API_KEY)

class App extends Component {
  constructor() {
    super();
    this.state = {
      showOverlay: true,
    };
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    this.props.getCardsRequest();
  }

  onClick() {
    this.setState({ showOverlay: false });
  }

  handleModal() {
    if (this.props.loading) {
      return <Loading />;
    }
  }

  render() {
    return (
      <>
        <GlobalStyle />
        <Header />
         {this.handleModal()}
        <Container fluid>
          <HashRouter>
            <Hero />
            <GlobalStyle />
            <Switch>
              <Route path="/" exact component={Home} />
            </Switch>
          </HashRouter>
        </Container> 
       <Footer />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cards: state.cards,
    loading: state.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCardsRequest: () => dispatch(getCardsRequest()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
